import React from 'react'

const FeedsHeader = () => {
    return (
        <div className="sondaria-feeds-header">
            <button className="sondaria-feeds-header-btn-active">Accueil</button>
            <button>Populaire</button>
            <button>Récent</button>
        </div>
    )
}

export default FeedsHeader